'use strict';

var assign = require('object-assign');

function UsersClient(client) {
  this.client = client;
}

assign(UsersClient.prototype, {
  getById: function getById(id) {
    return this.client.request({ uri: '/users/' + id });
  }
});

module.exports = UsersClient;


//////////////////
// WEBPACK FOOTER
// ./~/@sanity/client/lib/users/usersClient.js
// module id = 272
// module chunks = 0